
.dropzone {
  @include themify($themes) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: themed("neutral-tertiary");
    border: 1px solid themed("neutral-secondary");
    color: themed("neutral-primary");
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    padding: 25px 0;
    cursor: pointer;
    border-radius: 12px;
    margin: 15px 0;

    &.isDragOver {
      background-color: themed("neutral-secondary");
    }
  }
}